'use strict';

/*global app*/
/*global doFilter*/
/*global blockElement*/

function BasicQueue(containerId) {
  this.containerId = containerId;
  this.$container = null;
  this.$filterForm = null;
  this.$searchInput = null;

  this.isRedirected = false;

  this.processBulkAction = null;

  this.initBasic();
}

BasicQueue.prototype = $.extend({}, {
  constructor: 'BasicQueue',

  registerCallbacksBasic: function registerCallbacksBasic() {
    var _this = this;

    _this.$filterForm.on('change', 'input:radio', function () {
      _this.$filterForm.submit();
    });

    _this.$container.on('click', '.process-item', function () {
      _this.processItem($(this));

      return false;
    });

    _this.$container.on('click', '.queue__process-selected-button', function () {
      _this.processSelected();
    });

    var searchInQueueTimeout = null;
    $('body').on('keyup', '.search-in-queue input', function (e) {
      var $input = $(this);

      e = e || window.event;
      var keyCode = e.keyCode || e.which;

      if (keyCode === 13) {
        _this.submitFilter();
      } else {
        clearTimeout(searchInQueueTimeout);

        searchInQueueTimeout = setTimeout(function () {
          doFilter(_this.$container, 'queue-item', $input.val());
        }, 250);
      }
    });

    _this.$filterForm.on('submit', function () {
      console.log('submit');
      if (!app.internetConnectionManager.isOnline()) {
        app.internetConnectionManager.viewOfflineWarning();

        return false;
      }

      return true;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  focusFilterInput: function focusFilterInput() {
    var _this = this;

    _this.$searchInput.focus();

    return _this;
  },

  submitFilter: function submitFilter() {
    var _this = this;

    var $items = _this.getVisibleItems();
    if ($items.length === 1) {
      _this.doProcessItem($items.first().find('.process-item'));
    }

    return _this;
  },

  getProcessItemUrlBase: function getProcessItemUrlBase($item) {
    return $item.attr('href');
  },

  getProcessItemUrl: function getProcessItemUrl($item) {
    var _this = this;

    return _this.getProcessItemUrlBase($item);
  },

  doProcessItem: function doProcessItem($item) {
    var _this = this;

    if (!_this.isRedirected) {
      var href = _this.getProcessItemUrl($item);

      if (app.internetConnectionManager.isOnline()) {
        blockElement(_this.$container);

        _this.isRedirected = true;

        //obcas se stalo, ze se potkalo prenacteni stranky s odeslanim pozadavku na nacteni stranky - musime tedy zakazat automaticke prenacteni
        app.setParam('is_allowed_reload_page', false);

        location.href = href;
      } else {
        app.internetConnectionManager.viewOfflineWarning();
      }
    }

    return _this;
  },

  processItem: function processItem($item) {
    var _this = this;

    if ($item.hasClass('process-item--processed')) {
      app.confirmHtml(app.t('queue.item_is_processed'), function (res) {
        if (res) {
          _this.doProcessItem($item);
        }
      });
    } else {
      _this.doProcessItem($item);
    }

    return _this;
  },

  getVisibleItems: function getVisibleItems() {
    var _this = this;

    var $items = _this.$container.find('.queue-item-row:visible');

    return $items;
  },

  getSelectedItems: function getSelectedItems() {
    var _this = this;

    var $items = _this.$container.find('.queue-item-row').filter(function () {
      var $item = $(this);
      return $item.find(':checkbox').is(':checked');
    });

    return $items;
  },

  getProcessSelectedUrlBase: function getProcessSelectedUrlBase() {
    var _this = this;

    var $items = _this.getSelectedItems();

    var name = '';
    var records = [];
    $items.each(function () {
      var $checkbox = $(this).find(':checkbox');
      records.push($checkbox.val());

      name = $checkbox.attr('name');
    });

    return app.path(_this.processBulkAction) + name + '=' + records.join('&' + name + '=');
  },

  getProcessSelectedUrl: function getProcessSelectedUrl() {
    var _this = this;

    return _this.getProcessSelectedUrlBase();
  },

  doProcessSelected: function doProcessSelected() {
    var _this = this;

    if (!_this.isRedirected) {
      var $items = _this.getSelectedItems();
      if ($items.length === 0) {
        return _this;
      }

      blockElement(_this.$container);
      location.href = _this.getProcessSelectedUrl();

      _this.isRedirected = true;
    }
  },

  processSelected: function processSelected() {
    var _this = this;

    _this.doProcessSelected();

    return _this;
  },

  //----------------------------------------------------------------------------

  initBasic: function initBasic() {
    var _this = this;

    _this.$container =  $('#' + _this.containerId);
    _this.$filterForm = _this.$container.find('#queue-form');
    _this.$searchInput = _this.$container.find('input[name="search_in_queue"]');

    _this.registerCallbacksBasic();
    _this.focusFilterInput();

    return _this;
  }
});
